import { render, staticRenderFns } from "./ContractsControl.vue?vue&type=template&id=4f5fa7f2&"
import script from "./ContractsControl.vue?vue&type=script&lang=js&"
export * from "./ContractsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports